import { useMemo } from 'react';

import { BlockedOfferingsFlag, FEATURE_FLAGS, useFeature } from '@arrived/feature-flags';
import { OfferingShortName } from '@arrived/models';

export function useIsOfferingBlocked(offeringShortName: OfferingShortName) {
  const blockedOfferingsFlag = useFeature<BlockedOfferingsFlag>(FEATURE_FLAGS.BLOCKED_OFFERINGS);
  return useMemo(
    () => blockedOfferingsFlag.value?.properties.includes(offeringShortName),
    [blockedOfferingsFlag, offeringShortName]
  );
}
